import { StyledRow, StyledSvgIcon, TypographyRtl } from "theme/shared"

type CenterServicesProps = {
  data: string[]
}

const CenterServices = ({ data }: CenterServicesProps) => {
  return (
    <div>
      {!!data.length && (
        <>
          <TypographyRtl $mb="20px" variant="h3">
          שירותים והתמחויות
          </TypographyRtl>
          <StyledRow $wrap $fullWidth $gap="20px">
            {data.map((service, index) => (
              <StyledRow key={index} $gap="10px">
                <StyledSvgIcon
                  src={`/icons/Vicon.svg`}
                  w={13}
                  h={9}
                  alt="vIcon"
                />
                <TypographyRtl variant="body1">{service}</TypographyRtl>
              </StyledRow>
            ))}
          </StyledRow>
        </>
      )}
    </div>
  )
}

export default CenterServices
